const actions = {
  LOGIN: 'LOGIN',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_FAILED: 'LOGIN_FAILED',

  VERIFY_OTP: 'VERIFY_OTP',
  VERIFY_OTP_SUCCESS: 'VERIFY_OTP_SUCCESS',
  VERIFY_OTP_FAILED: 'VERIFY_OTP_FAILED',

  RESET_MESSAGE: 'RESET_MESSAGE',

  GET_USER_DATA_BY_TOKEN: "GET_USER_DATA_BY_TOKEN",
  GET_USER_DATA_BY_TOKEN_SUCCESS: "GET_USER_DATA_BY_TOKEN_SUCCESS",
  GET_USER_DATA_BY_TOKEN_FAILED: "GET_USER_DATA_BY_TOKEN_FAILED",


  FORGOT_PASSWORD_REQ: 'FORGOT_PASSWORD_REQ',
  FORGOT_PASSWORD_REQ_SUCCESS: 'FORGOT_PASSWORD_REQ_SUCCESS',
  FORGOT_PASSWORD_REQ_FAILED: 'FORGOT_PASSWORD_REQ_FAILED',

  FORGOT_PASSWORD: 'FORGOT_PASSWORD',
  FORGOT_PASSWORD_SUCCESS: 'FORGOT_PASSWORD_SUCCESS',
  FORGOT_PASSWORD_FAILED: 'FORGOT_PASSWORD_FAILED',

  RESET_PASSWORD: 'RESET_PASSWORD',
  RESET_PASSWORD_SUCCESS: 'RESET_PASSWORD_SUCCESS',
  RESET_PASSWORD_FAILED: 'RESET_PASSWORD_FAILED',


  login: (data) => ({
    type: actions.LOGIN,
    payload: { data },
  }),
  loginSuccess: (data, message) => ({
    type: actions.LOGIN_SUCCESS,
    payload: { data, message },
  }),
  loginFailed: (error) => ({
    type: actions.LOGIN_FAILED,
    payload: { error },
  }),


  verifyOtp: (data) => ({
    type: actions.VERIFY_OTP,
    payload: { data },
  }),
  verifyOtpSuccess: (result, message) => ({
    type: actions.VERIFY_OTP_SUCCESS,
    payload: { result, message },
  }),
  verifyOtpFailed: (error) => ({
    type: actions.VERIFY_OTP_FAILED,
    payload: { error },
  }),

  resetMessage: () => ({
    type: actions.RESET_MESSAGE,
  }),

  getUserDataByToken: () => ({
    type: actions.GET_USER_DATA_BY_TOKEN,
  }),
  getUserDataByTokenSuccess: (tokenData) => ({
    type: actions.GET_USER_DATA_BY_TOKEN_SUCCESS,
    tokenData
  }),
  getUserDataByTokenError: (tokenError) => ({
    type: actions.GET_USER_DATA_BY_TOKEN_FAILED,
    tokenError
  }),

  forgotPassword: (data) => ({
    type: actions.FORGOT_PASSWORD,
    payload: { data },
  }),
  forgotPasswordSuccess: (message) => ({
    type: actions.FORGOT_PASSWORD_SUCCESS,
    payload: { message },
  }),
  forgotPasswordFailed: (error) => ({
    type: actions.FORGOT_PASSWORD_FAILED,
    payload: { error },
  }),

   resetPassword: (data) => ({
    type: actions.RESET_PASSWORD,
    payload: { data },
  }),
  resetPasswordSuccess: (message) => ({
    type: actions.RESET_PASSWORD_SUCCESS,
    payload: { message },
  }),
  resetPasswordFailed: (error) => ({
    type: actions.RESET_PASSWORD_FAILED,
    payload: { error },
  }),
};
export default actions;
